import React from 'react';
import { Filter } from 'lucide-react';

const EVENT_TYPES = [
  'page_view',
  'content_click',
  'engagement',
  'conversion',
  'search',
  'form_interaction',
  'error',
  'custom',
  'test_event',
];

export interface EventFiltersState {
  eventType?: string;
  userId?: string;
  startDate?: string;
  endDate?: string;
  isTest?: boolean;
}

interface EventFiltersProps {
  filters: EventFiltersState;
  onChange: (filters: EventFiltersState) => void;
  onApply: () => void;
  loading?: boolean;
}

export default function EventFilters({ filters, onChange, onApply, loading }: EventFiltersProps) {
  return (
    <div className="bg-white p-4 rounded-lg shadow mb-4">
      <div className="flex items-center gap-2 mb-4">
        <Filter className="w-5 h-5 text-gray-500" />
        <h2 className="text-lg font-medium">Filters</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Event Type</label>
          <select
            value={filters.eventType || ''}
            onChange={e => onChange({ ...filters, eventType: e.target.value || undefined })}
            className="w-full border border-gray-300 rounded-md p-2 text-sm"
          >
            <option value="">All Types</option>
            {EVENT_TYPES.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">User ID</label>
          <input
            type="text"
            value={filters.userId || ''}
            onChange={e => onChange({ ...filters, userId: e.target.value || undefined })}
            placeholder="Filter by user..."
            className="w-full border border-gray-300 rounded-md p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
          <input
            type="datetime-local"
            value={filters.startDate || ''}
            onChange={e => onChange({ ...filters, startDate: e.target.value || undefined })}
            className="w-full border border-gray-300 rounded-md p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
          <input
            type="datetime-local"
            value={filters.endDate || ''}
            onChange={e => onChange({ ...filters, endDate: e.target.value || undefined })}
            className="w-full border border-gray-300 rounded-md p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Test Events</label>
          <select
            value={filters.isTest === undefined ? '' : String(filters.isTest)}
            onChange={e => onChange({
              ...filters,
              isTest: e.target.value === '' ? undefined : e.target.value === 'true'
            })}
            className="w-full border border-gray-300 rounded-md p-2 text-sm"
          >
            <option value="">All</option>
            <option value="false">Production Only</option>
            <option value="true">Test Only</option>
          </select>
        </div>
      </div>

      <div className="mt-4 flex justify-end">
        <button
          onClick={onApply}
          disabled={loading}
          className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Loading...' : 'Apply Filters'}
        </button>
      </div>
    </div>
  );
}
